// use-subscription-plans.ts — Subscription suite, query.

'use client';

import type { GetSubscriptionPlansResponse } from '@cabal/shared/domain/billing/subscription/types.js';
import { useApi } from '@/contexts/api';
import { useQueryHook } from '@/lib/query/use-query-hook';
import type { QueryResult } from '@/types/async-protocol';
import { subscriptionKeys } from './keys';

export type SubscriptionPlan = GetSubscriptionPlansResponse['plans'][number];

export function useSubscriptionPlans(): QueryResult<SubscriptionPlan[]> {
  const api = useApi();

  return useQueryHook<SubscriptionPlan[], Error>({
    queryKey: subscriptionKeys.plans(),
    queryFn: async () => {
      const result = await api.subscription.plans();
      return result.plans;
    },
  });
}
